import React from "react";
import HealthCard from "./HealthCard";
import { donutDash, formatNumber } from "../utils";

/**
 * fmd/20 data:
 * { availabilityPercent, totalVehicles, availableVehicles, unavailableVehicles }
 */
const FleetAvailability = ({ translate, data, loading }) => {
  const available = Number(data?.availableVehicles ?? 0);
  const inWorkshop = Number(data?.unavailableVehicles ?? 0);
  const total = Number(data?.totalVehicles ?? available + inWorkshop);
  const percent = Number(
    data?.availabilityPercent ?? (total ? (available / total) * 100 : 0),
  );
  const { dashArray } = donutDash(percent, 42);

  return (
    <HealthCard
      className="fh-span-3"
      title={translate("fleetAvailability")}
      subtitle={translate("fleetAvailabilitySub")}
      loading={loading}
    >
      <div className="fh-kpi-visual">
        <svg width="100" height="100" viewBox="0 0 120 120">
          <circle
            cx="60"
            cy="60"
            r="42"
            fill="none"
            stroke="#eef1f4"
            strokeWidth="14"
          />
          <circle
            cx="60"
            cy="60"
            r="42"
            fill="none"
            stroke="#5cb85c"
            strokeWidth="14"
            strokeDasharray={dashArray}
            transform="rotate(-90 60 60)"
          />
          <text
            x="60"
            y="58"
            textAnchor="middle"
            fontSize="18"
            fontWeight="700"
            fill="#22303c"
          >
            {formatNumber(percent, 1)}%
          </text>
          <text
            x="60"
            y="74"
            textAnchor="middle"
            fontSize="10"
            fill="#8a97a3"
          >
            {translate("available")}
          </text>
        </svg>
        <div className="fh-legend">
          <span>
            <i className="fh-dot" style={{ background: "#5cb85c" }} />
            {translate("available")} — {formatNumber(available)}
          </span>
          <span>
            <i className="fh-dot" style={{ background: "#dfe4e9" }} />
            {translate("inWorkshop")} — {formatNumber(inWorkshop)}
          </span>
        </div>
      </div>
      <div className="fh-kpi-meta">
        <div className="fh-metaline">
          <span>{translate("totalFleet")}</span>
          <b>{formatNumber(total)}</b>
        </div>
      </div>
    </HealthCard>
  );
};

export default FleetAvailability;
